import Vue from "vue";

Vue.filter("currency", function (value) {
  if (!value) {
    return 0;
  }
  return value
    .toString()
    .replace(".", ",")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});
